module.exports = __webpack_public_path__ + "img/mask.c09a7341.svg";